<div class="loading-screen" *ngIf="loading">
  <img src="assets/loading.gif" alt="Loading..." style="height: 100px"/>
</div>

